type storageType = "localStorage" | "sessionStorage";

const getObject = <T>(key: string, storageType: storageType = "localStorage"): T | null => {
  if (key.trim()) {
    const d = window[storageType].getItem(key.trim());
    if (d) {
      return JSON.parse(d);
    }
  }

  return null;
};

const setObject = <T>(obj: T, key: string, storageType: storageType = "localStorage"): boolean => {
  if (key.trim()) {
    try {
      window[storageType].setItem(key.trim(), JSON.stringify(obj));
      return true;
    } catch (e) {
      console.error(`Failed to set local storage for key ${key.trim()} - ${e}`);
    }
  }

  return false;
};

const deleteObject = (key: string, storageType: storageType = "localStorage"): boolean => {
  if (key.trim()) {
    try {
      window[storageType].removeItem(key.trim());
      return true;
    } catch (e) {
      console.error(`Failed to delete local storage for key ${key.trim()} - ${e}`);
    }
  }

  return false;
};

const isStorageAvailable = (storageType: storageType = "localStorage"): boolean => {
  let storage;
  try {
    const x = "__s1_storage_test__";
    storage = window[storageType];
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === "QuotaExceededError" ||
        // Firefox
        e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage.length !== 0
    );
  }
};

export { deleteObject, getObject, isStorageAvailable, setObject };
